import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal, Toast } from '../../../../uiComponents/common';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { WelletContext } from '../../../../context/wellet/welletContext';
import { putRetryPayment } from '../../../../services';
import { Show } from '../../../../components';

const ModalRetryPayment = ({ id, refetch }) => {
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation('translation', { keyPrefix: 'modals.modalRetryPayment' });
  const [openPayment, setOpenPayment] = useState(false);

  const retryMutation = useMutation({
    mutationFn: () => {
      return putRetryPayment(welletContext, id);
    },
  });

  const handleModal = () => {
    setOpenPayment((prevState) => !prevState);
  };
  const queryClient = useQueryClient();
  const handleRefetch = () => queryClient.refetchQueries({ queryKey: ['wire-detail', id] });
  const handleToastSucces = () => {
    handleRefetch();
    handleModal();
    retryMutation.reset();
  };

  return (
    <>
      <Button
        className={'btn-wellet-secondary bg-custom-light text-truncate btn-accept'}
        text={t('btnExecute')}
        onClick={handleModal}
        size={'custom'}
      />
      <Show.When isTrue={openPayment}>
        <Modal
          open={openPayment !== null}
          handleSubmit={() => retryMutation.mutate()}
          isLoading={retryMutation.isLoading || retryMutation.isSuccess}
          showComment={true}
          onClose={handleModal}
          title={t('title')}
          textCancel={t('cancel')}
          children={<div className='text-left mt-2'>{t('ask')}</div>}
          textSubmit={t('submit')}
          maxWidth={'450px'}
        />
      </Show.When>
      <Show.When isTrue={retryMutation?.error}>
        <Toast
          message={
            retryMutation?.error?.response?.data?.errorCode === 'PAYMENT_NOT_FOUND'
              ? t('paymentNotFound')
              : t('toastError')
          }
          type='ERROR'
          onCallback={() => {
            retryMutation.reset();
          }}
        />
      </Show.When>
      <Show.When isTrue={retryMutation?.isSuccess}>
        <Toast message={t('toastSuccess')} type='SUCCESS' onCallback={handleToastSucces} />
      </Show.When>
    </>
  );
};

export default ModalRetryPayment;
